export default __webpack_public_path__ + "static/media/Transfer2.d374a269.svg";